import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, isAuthError } from "../lib/api";
import { useAuth } from "./AuthContext";

const BillingContext = createContext(null);

export function BillingProvider({ children }) {
  const { user, ready, expireSession } = useAuth();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/status");
      setBilling(data);
    } catch (e) {
      setBilling(null);
      if (isAuthError(e) && expireSession) await expireSession();
    } finally {
      setLoading(false);
    }
  }, [expireSession]);

  useEffect(() => {
    if (ready && user) { setLoading(true); refresh(); }
    else if (ready && !user) { setBilling(null); setLoading(false); }
  }, [ready, user, refresh]);

  return (
    <BillingContext.Provider value={{ billing, loading, refresh }}>
      {children}
    </BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);
